import { createAction, props } from '@ngrx/store';
import { ServerMessage } from '../../models/server-message';
import { Shipment } from '../../models/shipment';

export const shipmentRefreshRequest = createAction(
    '[Shipment] Request Reload from server',
    props<{ shipmentId: string }>()
);

export const shipmentRefreshSucceeded = createAction(
    '[Shipment] Request Reload Succeeded',
    props<{ shipment: Shipment }>()
);

export const shipmentRefreshFailed = createAction(
    '[Shipment] Request Reload Failed',
    props<{ message: ServerMessage }>()
);

export const shipmentSubmitQuoteRequest = createAction(
    '[Shipment] Submit Shipment by Quote',
    props<{ shipmentId: string, quoteId: string }>()
);

export const shipmentSubmitQuoteSuccess = createAction(
    '[Shipment] Submission by Quote Succeeded',
    props<{ shipmentId: string }>()
);

export const shipmentSubmitQuoteFailure = createAction(
    '[Shipment] Submission by Quote Failed',
    props<{ shipmentId: string, message: ServerMessage }>()
);

export const shipmentVoidMultiRequest = createAction(
    '[Shipment] Void Shipments',
    props<{ shipmentIds: string[] }>()
);

export const shipmentVoidMultiSuccess = createAction(
    '[Shipment] Void Succeeded',
    props<{ shipmentIds: string[] }>()
);

export const shipmentVoidMultiFailure = createAction(
    '[Shipment] Void Failed',
    props<{ shipmentIds: string[], messages: ServerMessage[] }>()
);

export const shipmentVoidCurrent = createAction(
    '[Shipment] Void Shipment'
);
